import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import VisibilitySensor from 'react-visibility-sensor';
import { isGuest } from '../../helpers/auth';
import { propBool, propChildren, propStr, } from '../../helpers/custom-prop-types';
import FooterContent from './FooterContent';
import FooterStickyComponent from './FooterStickyComponent';
const Footer = (props) => {
    const { bottomContent, children, footerClassName, isLoading, renderStickyComponent, showHelp, showProffitSearchLink, stickyClassName, } = props;
    const [isShowFooter, changeIsShowFooter] = useState(false);
    const auth = useSelector((state) => state.auth);
    const isGuestUser = isGuest(auth);
    return (_jsxs("footer", Object.assign({ className: clsx('l-footer', footerClassName, isShowFooter && 'is-show-footer') }, { children: [_jsx(FooterStickyComponent, Object.assign({ className: stickyClassName, isLoading: isLoading, renderStickyComponent: renderStickyComponent, showHelp: showHelp, showProffitSearchLink: showProffitSearchLink }, { children: children })), _jsx(VisibilitySensor, Object.assign({ active: true, intervalDelay: 10, onChange: changeIsShowFooter, partialVisibility: true }, { children: _jsxs(_Fragment, { children: [bottomContent, _jsx(FooterContent, { isGuest: isGuestUser })] }) }))] })));
};
Footer.propTypes = {
    bottomContent: propChildren(),
    children: propChildren(),
    footerClassName: propStr(),
    isLoading: propBool(),
    renderStickyComponent: propChildren(),
    showHelp: propBool(),
    showProffitSearchLink: propBool(),
    stickyClassName: propStr(),
};
Footer.defaultProps = {
    bottomContent: null,
    children: null,
    footerClassName: '',
    isLoading: false,
    renderStickyComponent: undefined,
    showHelp: false,
    showProffitSearchLink: false,
    stickyClassName: '',
};
export default Footer;
